import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function SideBarItem(props) {
    const location = useLocation();

    function isActivePath(path) {
        if (path === '/') return location.pathname === '/';
        return location.pathname === path || location.pathname.startsWith(`${path}/`);
    }

    const isActive = isActivePath(props.to);
    const linkClasses = [
        'sidebar-link flex items-center rounded-lg transition-all duration-200 no-underline text-slate-700 hover:bg-blue-50 hover:text-blue-900 px-3 py-2.5',
        isActive ? 'sidebar-link-active-main' : '',
    ].filter(Boolean).join(' ');

    return (
        <li className="list-none">
            <Link to={props.to} className={linkClasses} onClick={props.onClick}>
                <span className="sidebar-text">{props.text}</span>
            </Link>
        </li>
    );
}

export default SideBarItem;
